import CheckoutPayment from './CheckoutPayment';

export default CheckoutPayment;
